// extracted by mini-css-extract-plugin
module.exports = {"image":"category-card-media_image__mK4Ur"};